import { DividerTemplate as FluentDividerTemplate } from "@fluentui/web-components";
/**
 * Template for the {@link Divider} component.
 * @public
 */
export const template = FluentDividerTemplate;
//# sourceMappingURL=divider.template.js.map